import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Col, Row, Typography } from 'antd'
import { getNs } from 'common/i18n-config'

import { Card } from '../styles'

const { t, useNsReady } = getNs(['components/organisms/assets/asset-form'])
const { Text, Title } = Typography
export const AILoading = () => {
  useNsReady()

  return (
    <Card>
      <Row align="middle" justify="space-between">
        <Col span={24}>
          <Row align="middle" gutter={12}>
            <Col>
              <FontAwesomeIcon icon={faSpinner} className="fa-spin" style={{ fontSize: '32px', color: '#3b7de9' }} />
            </Col>
            <Col>
              <div>
                <Title level={5}>{t('ai_is_analyzing')}</Title>
                <Text type="secondary" style={{ fontSize: '14px' }}>
                  {t('ai_analyzing_description')}
                </Text>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  )
}
